import { Injectable } from '@angular/core';
import { MinimalLS } from 'alyle-ui/ls';
var VibrantSwatch = /** @class */ (function () {
    function VibrantSwatch() {
    }
    return VibrantSwatch;
}());
export { VibrantSwatch };
var VibrantColors = /** @class */ (function () {
    function VibrantColors() {
        this.Vibrant = new VibrantSwatch;
        this.DarkVibrant = new VibrantSwatch;
        this.DarkMuted = new VibrantSwatch;
        this.Muted = new VibrantSwatch;
        this.LightVibrant = new VibrantSwatch;
    }
    return VibrantColors;
}());
export { VibrantColors };
var CarouselService = /** @class */ (function () {
    function CarouselService(ls) {
        this.ls = ls;
    }
    CarouselService.prototype.getColorVibrant = function (srcImg) {
        var _this = this;
        var v = new Vibrant(srcImg).getPalette();
        return v.then(function (pal) {
            if (pal) {
                _this.ls.setItem(srcImg, _this._palette(pal));
            }
        });
    };
    /**
     * return Vibrant & DarkVibrant
     */
    /**
       * return Vibrant & DarkVibrant
       */
    CarouselService.prototype._palette = /**
       * return Vibrant & DarkVibrant
       */
    function (pal) {
        var palette = {};
        for (var key in pal) {
            if (pal.hasOwnProperty(key)) {
                palette["" + key] = {
                    'bodyTextColor': pal[key].getBodyTextColor(),
                    'hex': pal[key].getHex(),
                    'titleTextColor': pal[key].getTitleTextColor(),
                    'yiq': pal[key].getYiq()
                };
            }
        }
        return palette;
    };
    CarouselService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    CarouselService.ctorParameters = function () { return [
        { type: MinimalLS, },
    ]; };
    return CarouselService;
}());
export { CarouselService };
//# sourceMappingURL=carousel.service.js.map